<template>
  <MainLayout>
    <template #default>

      <div class="">
        <div class="d-flex justify-content-center align-items-center p-5">
          <div class="text-center">
            <h1 class="">Bienvenido a Megacad</h1>
            <img :src="imageLogo" alt="" style="max-width: 400px; height: auto;">

            <!-- <h2>Permisos Actualizados:</h2>
            <ul>
              <li v-for="permission in permissions" :key="permission">{{ permission }}</li>
            </ul> -->
          </div>
        </div>
      </div>
    </template>
  </MainLayout>
</template>

<script>
import MainLayout from '../layouts/MainLayout';

export default {
  name: 'Home',

  components: {

    MainLayout,
  },


  data() {
    return {

      imageLogo: require('@/assets/images/logo-megacad.png'),
      socket: null,
      // permissions: [],
    };
  },

  created() {
    // // Conexión al WebSocket estándar
    // this.socket = new WebSocket('ws://localhost:8005/ws/permissions/');

    // // Escucha los mensajes de actualización de permisos
    // this.socket.onmessage = (event) => {
    //   const data = JSON.parse(event.data);
    //   if (data.permissions_data) {
    //     this.permissions = data.permissions_data;
    //     console.log('Permisos actualizados:', this.permissions);
    //   }
    // };

    // // Maneja la apertura de la conexión
    // this.socket.onopen = () => {
    //   console.log('Conexión WebSocket abierta');
    // };

    // // Maneja posibles errores de conexión
    // this.socket.onerror = (error) => {
    //   console.error('Error de conexión WebSocket:', error);
    // };

    // // Maneja el cierre de la conexión
    // this.socket.onclose = () => {
    //   console.log('Conexión WebSocket cerrada');
    // };

    // const socket = new WebSocket('ws://localhost:8005/ws/permissions/');

    // socket.onopen = function () {
    //   console.log('WebSocket conectado');
    //   // Enviar un mensaje al servidor
    //   socket.send(JSON.stringify({ 'message': 'Hola desde el cliente!' }));
    // };

    // socket.onmessage = function (event) {
    //     const data = JSON.parse(event.data);
        
    //     // Imprimir el mensaje en la consola
    //     console.log(data);
    // };

    //   // Evento que maneja errores
    //   socket.onerror = (error) => {
    //     console.error('Error de WebSocket:', error);
    //   };


    // socket.onclose = function () {
    //   console.log('Conexión cerrada');
    // };

  },

};
</script>

<style scoped></style>
